import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  CdrDocumentDraftDto,
  CdrDocumentFileContent,
  CdrImageUploadLinkCreationResponse,
  CdrImageUploadViewData,
  UpsertPatientMedicalDocumentDto
} from 'ts-types/api.types';


const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const getApiUri = (patientId: number) => `${baseUrl}/api/cdr/patient/${patientId}/document`;

export const addCdrDocument = (
    patientId: number,
    values: Partial<UpsertPatientMedicalDocumentDto>,
    source: CancelTokenSource): Promise<UpsertPatientMedicalDocumentDto> => {
  const apiUri = getApiUri(patientId);

  return axios
      .post(`${apiUri}`, values, {cancelToken: source.token})
      .then(response => response.data);
};

export const editCdrDocument = (
    patientId: number,
    documentId: number,
    values: Partial<UpsertPatientMedicalDocumentDto>,
    source: CancelTokenSource): Promise<UpsertPatientMedicalDocumentDto> => {
  const apiUri = getApiUri(patientId);

  return axios
      .put(`${apiUri}/${documentId}`, values, {cancelToken: source.token})
      .then(response => response.data);
};

export const getCdrDocumentFile = (
    patientId: number,
    documentId: number,
    documentFileId: number,
    cancelTokenSource: CancelTokenSource
): Promise<CdrDocumentFileContent> => {

  const apiUri = getApiUri(patientId);

  return axios
      .get(`${apiUri}/${documentId}/file/${documentFileId}`,
          {cancelToken: cancelTokenSource.token}
      )
      .then((response) => response.data);
};

export const createCdrDocumentDraft = (
    patientId: number,
    source: CancelTokenSource
): Promise<CdrDocumentDraftDto> => {
  const apiUri = getApiUri(patientId);

  return axios
      .post(`${apiUri}/draft`, {}, {cancelToken: source.token})
      .then((response) => response.data);
}

export const addFilesToDraft = (
    patientId: number,
    draftId: string,
    filesToAdd: File[],
    source: CancelTokenSource,
    onUploadProgress?: (progressEvent: any) => void
): Promise<CdrDocumentDraftDto> => {

  const apiUri = getApiUri(patientId);

  let bodyFormData = new FormData();
  filesToAdd.forEach((file) => {
    bodyFormData.append("files", file as File);
  });

  return axios
      .post(
          `${apiUri}/draft/${draftId}/file`,
          bodyFormData,
          {
            cancelToken: source.token,
            onUploadProgress
          }
      )
      .then((response) => response.data);
};

export const getCdrDocumentDraft = (
    patientId: number,
    draftId: string,
    source: CancelTokenSource
): Promise<CdrDocumentDraftDto> => {
  const apiUri = getApiUri(patientId);

  return axios
      .get(`${apiUri}/draft/${draftId}`, {cancelToken: source.token})
      .then((response) => response.data);
}


export const createCdrDocumentDraftBase64String = (
    patientId: number,
    draftId: string,
    source: CancelTokenSource
): Promise<CdrImageUploadLinkCreationResponse> => {

  const apiUri = getApiUri(patientId);

  return axios
      .post(
          `${apiUri}/draft/${draftId}/qrcode`,
          {},
          {cancelToken: source.token}
      )
      .then(response => response.data);
};

export const getCdrImageUploadViewData = (
    token: string,
    source: CancelTokenSource
): Promise<CdrImageUploadViewData> => {
  return axios
      .get(
          `${baseUrl}/public/api/cdr/patient/document/draft/${token}/token-data`,
          {params: {token}, cancelToken: source.token}
      )
      .then(response => response.data);
};

export const addSnapshotToDraft = (
    token: string,
    file: any,
    source: CancelTokenSource
): Promise<any> => {

  const formData = new FormData();
  formData.append("file", file);

  return axios
      .post(
          `${baseUrl}/public/api/cdr/patient/document/draft/${token}/file`,
          formData,
          {cancelToken: source.token}
      )
      .then(response => response.data);
};


export const deleteCdrDocumentDraft = (
    patientId: number,
    draftId: string,
    source: CancelTokenSource
) => {
  const apiUri = getApiUri(patientId);

  return axios.delete(
          `${apiUri}/draft/${draftId}`,
          {cancelToken: source.token})
      .then(response => response.data);
}

export const deleteCdrDocumentDraftFile = (
    patientId: number,
    draftId: string,
    fileId: number,
    source: CancelTokenSource
): Promise<CdrDocumentDraftDto> => {
  const apiUri = getApiUri(patientId);

  return axios.delete(
          `${apiUri}/draft/${draftId}/file/${fileId}`,
          {cancelToken: source.token})
      .then(response => response.data);
}

export const getCdrDocumentDraftFile = (
    patientId: number,
    draftId: string,
    draftFileId: number,
    cancelTokenSource: CancelTokenSource
): Promise<CdrDocumentFileContent> => {

  const apiUri = getApiUri(patientId);

  return axios
      .get(`${apiUri}/draft/${draftId}/file/${draftFileId}`,
          {cancelToken: cancelTokenSource.token}
      )
      .then((response) => response.data);
};
